import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import get from 'lodash/get';

export const ARTIST_FEED_QUERY = Component => gql`
  query artistFeed($country: String!, $currency: String!, $locale: String!) {
    artistFeed(country: $country, currency: $currency, locale: $locale) {
      ...${Component.displayName}
    }
  }
  ${Component.fragment}
`;

const withArtistFeed = Component =>
  graphql(ARTIST_FEED_QUERY(Component), {
    props: ({ data: { loading, artistFeed }, ownProps }) => {
      return {
        ...ownProps,
        loading: ownProps.loading || loading,
        artistFeed
      };
    },
    skip: ({ userInfo }) => {
      const info = userInfo || {};
      return !(info.country && info.currency && info.locale);
    },
    options: props => ({
      variables: {
        country: get(props, 'userInfo.country'),
        currency: get(props, 'userInfo.currency'),
        locale: get(props, 'userInfo.locale')
      }
    })
  })(Component);

withArtistFeed.displayName = 'withArtistFeed';

export default withArtistFeed;
